<template>
  <div>
    <v-card>
      <v-card-title>
        Akses Kontrol
        <v-spacer />

        <v-btn v-if="!isEdit" color="primary" dark @click="doEdit">
          Edit
        </v-btn>
      </v-card-title>

      <v-card-text>
        <div>Konten</div>
        <div v-if="isFetching" class="text-h5">Sedang memuat ...</div>
        <VRow v-else>
          <VCol cols="12">
            <v-list nav dense>
              <v-list-item>
                <v-checkbox
                  v-model="inputAksesControl"
                  dense
                  hide-details
                  :value="1"
                  label="Dashboard"
                  :readonly="!isEdit"
                ></v-checkbox>
              </v-list-item>

              <v-list-item>
                <v-checkbox
                  v-model="inputAksesControl"
                  dense
                  hide-details
                  :value="2"
                  label="SDM Medis"
                  :readonly="!isEdit"
                ></v-checkbox>
              </v-list-item>

              <v-list-item>
                <v-checkbox
                  v-model="inputAksesControl"
                  dense
                  hide-details
                  :value="3"
                  label="Informasi Broadcast"
                  :readonly="!isEdit"
                ></v-checkbox>
              </v-list-item>

              <v-list-item>
                <v-checkbox
                  v-model="inputAksesControl"
                  dense
                  hide-details
                  :value="4"
                  label="Jadwal Praktek Dokter"
                  :readonly="!isEdit"
                ></v-checkbox>
              </v-list-item>

              <v-list-group no-action>
                <template #activator>
                  <v-list-item-content>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="5"
                      label="Telemedicine"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item-content>
                </template>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="6"
                    label="Tim Telemedicine"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="7"
                    label="Jadwal Konsultasi"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="8"
                    label="Riwayat Konsultasi Online"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="46"
                    label="Pasien"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="9"
                    label="Setting Telemedicine"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="10"
                    label="Term and Condition Telemedicine"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-group no-action sub-group>
                  <template #activator>
                    <v-list-item-content>
                      <v-checkbox
                        v-model="inputAksesControl"
                        dense
                        hide-details
                        :value="11"
                        label="Master Obat"
                        :readonly="!isEdit"
                      ></v-checkbox>
                    </v-list-item-content>
                  </template>

                  <v-list-item>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="12"
                      label="Obat"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="13"
                      label="Supplier"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="14"
                      label="Kategori Obat"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="15"
                      label="Satuan Unit Obat"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item>
                </v-list-group>
              </v-list-group>

              <v-list-group no-action>
                <template #activator>
                  <v-list-item-content>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="16"
                      label="Web Content"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item-content>
                </template>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="17"
                    label="Agenda Pelatihan"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="18"
                    label="Artikel (Healthpedia)"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="19"
                    label="Kategori Artikel"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="20"
                    label="Berita"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="21"
                    label="Kategori Berita"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="22"
                    label="Pengurus"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="23"
                    label="Sejarah"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="24"
                    label="Setting RS"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="25"
                    label="Struktur Organisasi"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="26"
                    label="Summary Layanan"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="27"
                    label="Testimoni"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="28"
                    label="Visi Misi"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="29"
                    label="Hubungi Kami"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="30"
                    label="Karir"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>
              </v-list-group>

              <v-list-group no-action>
                <template #activator>
                  <v-list-item-content>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="31"
                      label="Master"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item-content>
                </template>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="32"
                    label="Rumah Sakit"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="33"
                    label="Klinik Eksekutif"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="34"
                    label="Home Care"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="35"
                    label="MCU"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="36"
                    label="Bank"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="37"
                    label="Jabatan"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="38"
                    label="Komunitas"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="39"
                    label="Layanan Superior"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="40"
                    label="Partnership"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="41"
                    label="Poli"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-item>
                  <v-checkbox
                    v-model="inputAksesControl"
                    dense
                    hide-details
                    :value="42"
                    label="Profesi"
                    :readonly="!isEdit"
                  ></v-checkbox>
                </v-list-item>

                <v-list-group no-action sub-group>
                  <template #activator>
                    <v-list-item-content>
                      <v-checkbox
                        v-model="inputAksesControl"
                        dense
                        hide-details
                        :value="43"
                        label="Master User"
                        :readonly="!isEdit"
                      ></v-checkbox>
                    </v-list-item-content>
                  </template>

                  <v-list-item>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="44"
                      label="User"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item>

                  <v-list-item>
                    <v-checkbox
                      v-model="inputAksesControl"
                      dense
                      hide-details
                      :value="45"
                      label="Role"
                      :readonly="!isEdit"
                    ></v-checkbox>
                  </v-list-item>
                </v-list-group>
              </v-list-group>
            </v-list>
          </VCol>
        </VRow>
      </v-card-text>
      <v-card-actions v-if="isEdit">
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="isEdit = false">
          Cancel
        </v-btn>
        <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import AksesKontrolService from "../../services/master/AksesKontrolService";
import CommonService from "../../services/CommonService";

export default {
  props: {
    id: Number,
  },
  data: () => ({
    isFetching: false,
    childKey: 0,
    selected: [],
    isFirst: false,
    options: {
      itemsPerPage: 10,
    },

    inputAksesControl: [],
    isEdit: false,
  }),
  watch: {
    selected: {
      handler() {
        if (this.selected != undefined && this.selected[0]) {
          this.childKey++;
        }
      },
      deep: true,
    },
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
  },
  methods: {
    getDataFromApi() {
      this.isFetching = true;
      AksesKontrolService.aksesKontrolAll(this.id)
        .then((res) => {
          this.inputAksesControl = res.data.list_data;
          this.isFetching = false;
        })
        .catch((err) => {
          this.isFetching = false;
          console.log(err);
          CommonService.showErrorToast("Terjadi kesalahan. Muat ulang");
        });
    },

    doEdit: async function () {
      console.log("do add");
      this.isEdit = true;
    },

    doSave: async function () {
      console.log(this.id);
      console.log(this.inputAksesControl);

      AksesKontrolService.update({
        role_id: this.id,
        akses_kontrol: this.inputAksesControl,
      })
        .then((res) => {
          this.dialog = false;

          console.log(res);
          CommonService.showSuccessToast("Update akses berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);
          CommonService.showErrorToast("Update akses gagal. Coba lagi");
        });
    },
  },
};
</script>
